import { render, staticRenderFns } from "./login.vue?vue&type=template&id=1a7230c5&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"
import style0 from "./login.vue?vue&type=style&index=0&id=1a7230c5&prod&scoped=true&lang=css"
import style1 from "./login.vue?vue&type=style&index=1&id=1a7230c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7230c5",
  null
  
)

export default component.exports